// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
.shark .divider.xxl {
  margin: 2.8rem;
}
.shark .divider.xl {
  margin: 2.5rem;
}
.shark .divider.lg {
  margin: 2rem;
}
.shark .divider.md {
  margin: 1.5rem;
}
.shark .divider.std {
  margin: 1rem;
}
.shark .divider.sm {
  margin: 0.75rem;
}
.shark .divider.xs {
  margin: 0.5rem;
}
.shark .divider.xxs {
  margin: 0.35rem;
}
.shark .divider.mi {
  margin: 0.2rem;
}
.shark .divider.none {
  margin: 0;
}
.shark .divider.vertical {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0;
  min-height: 100%;
}
.shark .divider.vertical.very-light-grey {
  border-left: 2px solid #f2f2f2;
}
.shark .divider.vertical.light-grey {
  border-left: 2px solid #d7d7d7;
}
.shark .divider.horizontal {
  background-color: #f2f2f2;
  display: block;
  margin-right: 0;
  margin-left: 0;
  height: 2px;
  min-width: 100%;
}
.shark .divider.horizontal.very-light-grey {
  background-color: #f2f2f2;
}
.shark .divider.horizontal.light-grey {
  background-color: #d7d7d7;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRpdmlkZXIuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Q0FHQztBQUNEOzs7Q0FHQztBQUNELFlBQVk7QUFDWixXQUFXO0FBQ1gsVUFBVTtBQUNWLFlBQVk7QUFDWixTQUFTO0FBQ1QsVUFBVTtBQUNWLFVBQVU7QUFDVixTQUFTO0FBQ1QsU0FBUztBQUNULGlCQUFpQjtBQUNqQixpQkFBaUI7QUFDakIsaUJBQWlCO0FBQ2pCLGtCQUFrQjtBQUNsQixtQkFBbUI7QUFDbkI7O0NBRUM7QUFDRDs7Q0FFQztBQUNEOzs7OztDQUtDO0FBQ0Q7Ozs7O0NBS0M7QUFDRDtFQUNFLGNBQWM7QUFDaEI7QUFDQTtFQUNFLGNBQWM7QUFDaEI7QUFDQTtFQUNFLFlBQVk7QUFDZDtBQUNBO0VBQ0UsY0FBYztBQUNoQjtBQUNBO0VBQ0UsWUFBWTtBQUNkO0FBQ0E7RUFDRSxlQUFlO0FBQ2pCO0FBQ0E7RUFDRSxjQUFjO0FBQ2hCO0FBQ0E7RUFDRSxlQUFlO0FBQ2pCO0FBQ0E7RUFDRSxjQUFjO0FBQ2hCO0FBQ0E7RUFDRSxTQUFTO0FBQ1g7QUFDQTtFQUNFLHFCQUFxQjtFQUNyQixhQUFhO0VBQ2IsZ0JBQWdCO0VBQ2hCLGdCQUFnQjtBQUNsQjtBQUNBO0VBQ0UsOEJBQThCO0FBQ2hDO0FBQ0E7RUFDRSw4QkFBOEI7QUFDaEM7QUFDQTtFQUNFLHlCQUF5QjtFQUN6QixjQUFjO0VBQ2QsZUFBZTtFQUNmLGNBQWM7RUFDZCxXQUFXO0VBQ1gsZUFBZTtBQUNqQjtBQUNBO0VBQ0UseUJBQXlCO0FBQzNCO0FBQ0E7RUFDRSx5QkFBeUI7QUFDM0IiLCJmaWxlIjoiZGl2aWRlci5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiogU1RPUllCT09LXG4qIElmIHlvdSBhZGQgYW55IHZhcmlhYmxlLCByZW1lbWJlciB0byBtYXAgaXQgaW50byB0aGUgcHJvcGVyIFN0b3J5XG4qL1xuLyoqXG4qIENvbG9yIHBhbGV0dGUgLSBGYWNpbGUuaXRcbiogaHR0cHM6Ly93d3cuZmlnbWEuY29tL2Rlc2lnbi9weUplTEZOYzN0cEZ0NU5rV3BidDhuL0NvcmUtRm91bmRhdGlvbi0lNUIxLjElNUQ/bm9kZS1pZD0zLTQyMTkmdD1Eamd0U2VFOE5nR2F4cEZtLTFcbiovXG4vKiBQcmltYXJ5ICovXG4vKiBBY3Rpb24gKi9cbi8qIEFsZXJ0ICovXG4vKiBTdWNjZXNzICovXG4vKiBIZWxwICovXG4vKiBFcnJvciAqL1xuLyogQ2hpY2sgKi9cbi8qIFRleHQgKi9cbi8qIEdyZXkgKi9cbi8qIE5ldXRyYWwvd2FybSAqL1xuLyogTmV1dHJhbC9jb2xkICovXG4vKiBPcGFjaXR5L0dyZXkgKi9cbi8qIE9wYWNpdHkvV2hpdGUgKi9cbi8qIE9wYWNpdHkvQ29sb3JzICovXG4vKipcbiogQ29sb3IgbWFwIC0gRmFjaWxlLml0XG4qL1xuLyoqXG4qIEBkZXByZWNhdGVkIHVzZSBDb2xvciAtIEZhY2lsZS5pdCBwYWxldHRlXG4qL1xuLyoqXG4qIFJlbW92ZXMgYSBzcGVjaWZpYyBpdGVtIGZyb20gYSBsaXN0LlxuKlxuKiBAcGFyYW0ge2xpc3R9ICRsaXN0IExpc3QuIEBwYXJhbSB7aW50ZWdlcn0gJGluZGV4IEluZGV4LlxuKiBAcmV0dXJuIHtsaXN0fSBVcGRhdGVkIGxpc3QuXG4qL1xuLyoqXG4qIEdldHMgYSB2YWx1ZSBmcm9tIGEgbWFwLlxuKlxuKiBAcGFyYW0ge21hcH0gJG1hcCBNYXAuXG4qIEByZXR1cm4ge3N0cmluZ30gVmFsdWUuXG4qL1xuLnNoYXJrIC5kaXZpZGVyLnh4bCB7XG4gIG1hcmdpbjogMi44cmVtO1xufVxuLnNoYXJrIC5kaXZpZGVyLnhsIHtcbiAgbWFyZ2luOiAyLjVyZW07XG59XG4uc2hhcmsgLmRpdmlkZXIubGcge1xuICBtYXJnaW46IDJyZW07XG59XG4uc2hhcmsgLmRpdmlkZXIubWQge1xuICBtYXJnaW46IDEuNXJlbTtcbn1cbi5zaGFyayAuZGl2aWRlci5zdGQge1xuICBtYXJnaW46IDFyZW07XG59XG4uc2hhcmsgLmRpdmlkZXIuc20ge1xuICBtYXJnaW46IDAuNzVyZW07XG59XG4uc2hhcmsgLmRpdmlkZXIueHMge1xuICBtYXJnaW46IDAuNXJlbTtcbn1cbi5zaGFyayAuZGl2aWRlci54eHMge1xuICBtYXJnaW46IDAuMzVyZW07XG59XG4uc2hhcmsgLmRpdmlkZXIubWkge1xuICBtYXJnaW46IDAuMnJlbTtcbn1cbi5zaGFyayAuZGl2aWRlci5ub25lIHtcbiAgbWFyZ2luOiAwO1xufVxuLnNoYXJrIC5kaXZpZGVyLnZlcnRpY2FsIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tdG9wOiAwO1xuICBtYXJnaW4tYm90dG9tOiAwO1xuICBtaW4taGVpZ2h0OiAxMDAlO1xufVxuLnNoYXJrIC5kaXZpZGVyLnZlcnRpY2FsLnZlcnktbGlnaHQtZ3JleSB7XG4gIGJvcmRlci1sZWZ0OiAycHggc29saWQgI2YyZjJmMjtcbn1cbi5zaGFyayAuZGl2aWRlci52ZXJ0aWNhbC5saWdodC1ncmV5IHtcbiAgYm9yZGVyLWxlZnQ6IDJweCBzb2xpZCAjZDdkN2Q3O1xufVxuLnNoYXJrIC5kaXZpZGVyLmhvcml6b250YWwge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjJmMmYyO1xuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLXJpZ2h0OiAwO1xuICBtYXJnaW4tbGVmdDogMDtcbiAgaGVpZ2h0OiAycHg7XG4gIG1pbi13aWR0aDogMTAwJTtcbn1cbi5zaGFyayAuZGl2aWRlci5ob3Jpem9udGFsLnZlcnktbGlnaHQtZ3JleSB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmMmYyZjI7XG59XG4uc2hhcmsgLmRpdmlkZXIuaG9yaXpvbnRhbC5saWdodC1ncmV5IHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2Q3ZDdkNztcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/Divider/divider.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,46GAA46G","sourcesContent":["/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n.shark .divider.xxl {\n  margin: 2.8rem;\n}\n.shark .divider.xl {\n  margin: 2.5rem;\n}\n.shark .divider.lg {\n  margin: 2rem;\n}\n.shark .divider.md {\n  margin: 1.5rem;\n}\n.shark .divider.std {\n  margin: 1rem;\n}\n.shark .divider.sm {\n  margin: 0.75rem;\n}\n.shark .divider.xs {\n  margin: 0.5rem;\n}\n.shark .divider.xxs {\n  margin: 0.35rem;\n}\n.shark .divider.mi {\n  margin: 0.2rem;\n}\n.shark .divider.none {\n  margin: 0;\n}\n.shark .divider.vertical {\n  display: inline-block;\n  margin-top: 0;\n  margin-bottom: 0;\n  min-height: 100%;\n}\n.shark .divider.vertical.very-light-grey {\n  border-left: 2px solid #f2f2f2;\n}\n.shark .divider.vertical.light-grey {\n  border-left: 2px solid #d7d7d7;\n}\n.shark .divider.horizontal {\n  background-color: #f2f2f2;\n  display: block;\n  margin-right: 0;\n  margin-left: 0;\n  height: 2px;\n  min-width: 100%;\n}\n.shark .divider.horizontal.very-light-grey {\n  background-color: #f2f2f2;\n}\n.shark .divider.horizontal.light-grey {\n  background-color: #d7d7d7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
